import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { usePinOverrideStore } from "@/store/pin-override-store";

/** Renders an AlertDialog when the backend returns
 *  ``409 { code: "pin_override_required" }`` on an apply-plan flow.
 *  The reservations the plan would relocate have a pin level (ZONE
 *  outside their preferred zone, or TABLE anywhere) that breaks the
 *  pin contract. Confirming opts in and the pin auto-adjusts. */
export function PinOverrideDialog() {
  const pending = usePinOverrideStore((s) => s.pending);
  const close = usePinOverrideStore((s) => s.close);

  const ctx = pending?.context;
  const blocked = ctx?.blocked ?? [];
  const hasTable = blocked.some((b) => b.pin_level === "table");
  const hasZone = blocked.some((b) => b.pin_level === "zone");

  return (
    <AlertDialog
      open={pending !== null}
      onOpenChange={(open) => {
        if (!open) close(false);
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {blocked.length === 1 ? "¿Mover reserva fijada?" : "¿Mover reservas fijadas?"}
          </AlertDialogTitle>
          <AlertDialogDescription>
            <span className="block">
              {blocked.length === 1
                ? "Esta reserva tiene una preferencia que se va a romper si la mueves:"
                : `Estas ${blocked.length} reservas tienen una preferencia que se va a romper si las mueves:`}
            </span>
            <ul className="mt-2 flex flex-col gap-1 text-foreground">
              {blocked.map((b) => (
                <li key={b.reservation_id} className="text-sm leading-snug">
                  <strong>{b.guest_name || "Sin nombre"}</strong>
                  <span className="ml-1 text-xs text-muted-foreground">
                    {b.pin_level === "table"
                      ? "— fijada a una mesa específica"
                      : "— fijada a su zona preferida"}
                  </span>
                </li>
              ))}
            </ul>
            <span className="mt-3 block text-xs text-muted-foreground">
              {hasZone && !hasTable
                ? "Al confirmar, el pin de zona se libera para que la reserva pueda moverse a otra zona."
                : hasTable && !hasZone
                  ? "Al confirmar, la reserva se reasigna a las nuevas mesas (manteniendo el pin)."
                  : "Al confirmar, los pines se ajustan según la nueva ubicación."}
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => close(false)}>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={() => close(true)}>Mover igual</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
